import { Grid, SelectChangeEvent } from "@mui/material";
import { GroupPermission } from "../../../../../model/GroupModel";
import { UserPermission } from "../../../../../model/UserModel";
import { KeyDriveBodyMax } from "../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";
import { KeyDriveTab } from "../../../../../components/KeydriveComponents/Tabs/KeyDriveTab";
import { Group, Person } from "@mui/icons-material";
import { KeyDriveTabPanel } from "../../../../../components/KeydriveComponents/Tabs/components/KeyDriveTabPanel";
import EditFolderUserBoxItem from "./EditFolderUserBoxItem";
import EditFolderGroupBoxItem from "./EditFolderGroupBoxItem";
import { KeyDriveTab2 } from "../../../../../components/KeydriveComponents/Tabs/KeydriveTab2";


interface IEditFolderPrivilegeListing {
    value: number;
    setValue: (set: number) => void;
    usersPermission: UserPermission[];
    groupPermission: GroupPermission[];
}

function EditFolderPrivilegeListing({
    setValue,
    value,
    groupPermission,
    usersPermission,
}: IEditFolderPrivilegeListing) {
    return (
        <>
            <Grid item xs={12} mt="30px">
                <KeyDriveBodyMax 
                    needBold
                    needEllipses={false}
                    color='#2d2d2d'
                    text='Gerenciar Privilégios'
                />
            </Grid>
            <Grid item xs={12} mt="20px">
                <KeyDriveTab2
                    numberOfTabs={2}
                    icon1={<Person />}
                    label1="Usuários"
                    icon2={<Group />}
                    label2="Grupos"
                    onChange={(_, i) => { setValue(i) }}
                >
                    <KeyDriveTabPanel
                        index={0}
                        value={value}
                    >
                        { usersPermission.map(({
                            userName,
                            permissionType,
                            userId
                        }) => (
                            <EditFolderUserBoxItem
                                permissionType={permissionType}
                                userName={userName}
                            />
                        )) }
                    </KeyDriveTabPanel>
                    <KeyDriveTabPanel
                        index={1}
                        value={value}
                    >
                        { groupPermission.map(({
                            groupName,
                            permissionType,
                        }) => (
                            <EditFolderGroupBoxItem
                                groupName={groupName}
                                permissionType={permissionType}
                            />
                        )) }
                    </KeyDriveTabPanel>
                </KeyDriveTab2>
            </Grid>
        </>
    );
}

export default EditFolderPrivilegeListing;